import ADB from "../../../../libs/MediaSDK";
import { akamai } from "../../../globals";
import { debug } from "@medscape/streaming-video-player/src/js/utils/debug-log";
const { Event: ADB_MEDIA_EVENTS } = ADB.Media;
const { DESTROY } = akamai.amp.Events;
const CC_VISIBILITY_CHANGE = "cc_visibilitychange";
class ClosedCaptions {
  constructor(amp, tracker, stateObjects) {
    this.amp = amp;
    this.tracker = tracker;
    this.stateObjects = stateObjects;
    this.subscriptions = [];
    debug.log("[MediaAnalyticsTracking][ClosedCaptions][constructor]:", this);
  }

  destroy() {
    this.subscriptions.forEach((subscription) => {
      subscription?.unsubscribe();
    });
    this.subscriptions = [];
  }
  end() {
    this.destroy();
  }
  start() {
    this.destroy();
    const { amp } = this;
    this.displayState = amp.displayState;
    const visibility$ = amp.AmpEventsSources[CC_VISIBILITY_CHANGE]?.subscribe(
      (data) => {
        this.onVisibilityChange();
      }
    );
    const destroy$ = amp.AmpEventsSources[DESTROY]?.subscribe((data) => {
      this.destroy();
    });
    this.subscriptions = [destroy$, visibility$];
    if (amp.captioning && amp.captioning.visible) {
      this.onVisibilityChange();
    }
  }

  onVisibilityChange() {
    const { tracker, amp, stateObjects } = this;
    const { ClosedCaption: stateObject } = stateObjects;
    const stateName =
      amp.captioning && amp.captioning.visible
        ? ADB_MEDIA_EVENTS.StateStart
        : ADB_MEDIA_EVENTS.StateEnd;
    debug.log(
      "[MediaAnalyticsTracking][onCc_visibilitychange] tracker.trackEvent \n\tstateName:",
      stateName,
      "\n\tstateObject:",
      stateObject
    );
    tracker.trackEvent(stateName, stateObject);
  }
}

export default ClosedCaptions;
